<template>
  <div class="app">
    <vue-progress-bar></vue-progress-bar>
    <notifications>
    </notifications>
    <AppHeader/>
    <div class="app-body">
      <Sidebar :navItems="nav"/>
      <main class="main">
        <breadcrumb :list="list"/>
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <AppFooter/>
  </div>
</template>

<style  lang="scss">
  .custom-template {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    text-align: left;
    font-size: 13px;
    margin: 5px;
    margin-bottom: 0;
    align-items: center;
    justify-content: center;
    &, & > div {
      box-sizing: border-box;
    }
    background: #E8F9F0;
    border: 2px solid #D0F2E1;
    .custom-template-icon {
      flex: 0 1 auto;
      color: #15C371;
      font-size: 32px;
      padding: 0 10px;
    }
    .custom-template-close {
      flex: 0 1 auto;
      padding: 0 20px;
      font-size: 16px;
      opacity: 0.2;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .custom-template-content {
      padding: 10px;
      flex: 1 0 auto;
      .custom-template-title {
        letter-spacing: 1px;
        text-transform: uppercase;
        font-size: 10px;
        font-weight: 600;
      }
    }
  }
  .nav-dropdown-items .nav-link {
    padding-left: 2rem;
  }
</style>

<script>
import { Header as AppHeader, Sidebar, Footer as AppFooter, Breadcrumb } from '../components/'

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
    AppFooter,
    Breadcrumb
  },
  data () {
    return {
      nav: [
        {
          role: 'report',
          title: true,
          name: 'report',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        },
        {
          // role: 'dashboard',
          name: 'dashboard',
          url: '/dashboard',
          icon: 'icon-speedometer'
        },
        {
          // role: 'sale.history',
          name: 'sales_history',
          url: '/sales-history',
          icon: 'icon-speedometer'
        },
        {
          // role: 'product.mix',
          name: 'product_mix',
          url: '/product-mix',
          icon: 'icon-speedometer'
        },
        {
          // role: 'order.time',
          name: 'order_processing_time',
          url: '/order-processing-time',
          icon: 'icon-speedometer'
        },
        {
          // role: 'report',
          name: 'report',
          url: '/report',
          icon: 'fa fa-bar-chart'
        },
        {
          // role: 'system',
          title: true,
          name: 'system',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        },
        {
          // role: 'user.list',
          name: 'user',
          url: '/user',
          icon: 'fa fa-user-o'
        },
        {
          // role: 'role.list',
          name: 'role',
          url: '/role',
          icon: 'fa fa-users'
        },
        {
          // role: 'permission.list',
          name: 'permission',
          url: '/permission',
          icon: 'fa fa-balance-scale'
        },
        {
          // role: 'client.list',
          name: 'client',
          url: '/client',
          icon: 'fa fa-globe'
        },
        {
          // role: 'master.inventory',
          title: true,
          name: 'inventory',
          class: '',
          wrapper: {
            element: '',
            attributes: {}
          }
        },
        {
          // role: 'master.inventory',
          name: 'master_data',
          url: '/inventory',
          icon: 'fa fa-tasks',
          children: [
            {
              // role: 'master_group.list',
              name: 'group',
              url: '/inventory/master-group',
              icon: 'icon-puzzle'
            },
            {
              // role: 'master_type.list',
              name: 'type',
              url: '/inventory/master-type',
              icon: 'fa fa-tag'
            },
            {
              // role: 'master_account.list',
              name: 'account',
              url: '/inventory/master-account',
              icon: 'fa fa-user'
            },
            {
              // role: 'master_supplier.list',
              name: 'supplier',
              url: '/inventory/master-supplier',
              icon: 'fa fa-user-secret'
            },
            {
              // role: 'master_genstore.list',
              name: 'genstore',
              url: '/inventory/master-genstore',
              icon: 'fa fa-tag'
            },
            {
              // role: 'master_uom.list',
              name: 'uom',
              url: '/inventory/master-uom',
              icon: 'fa fa-tag'
            },
            {
              // role: 'master_uom_detail.list',
              name: 'uom_detail',
              url: '/inventory/master-uom-detail',
              icon: 'fa fa-tag'
            },
            {
              // role: 'master_material.list',
              name: 'material',
              url: '/inventory/master-material',
              icon: 'fa fa-user-secret'
            },
            {
              // role: 'master_material_detail.list',
              name: 'material_detail',
              url: '/inventory/master-material-detail',
              icon: 'fa fa-user-secret'
            },
            {
              // role: 'master_material_detail_supplier.list',
              name: 'material_detail_supplier',
              url: '/inventory/master-material-detail-supplier',
              icon: 'fa fa-user-secret'
            },
            {
              // role: 'master_material_recipe_mapping.list',
              name: 'master_material_recipe_mapping',
              url: '/inventory/master-material-recipe-mapping',
              icon: 'fa fa-user-secret'
            },
            {
              // role: 'master_recipe.list',
              name: 'recipe',
              url: '/inventory/master-recipe',
              icon: 'fa fa-user-secret'
            }
          ]
        },
        {
          // role: 'master.inventory',
          name: 'sync_data',
          url: '/inventory',
          icon: 'fa fa-tasks',
          children: [
            {
              // role: 'sync_master.list',
              name: 'sync_master',
              url: '/inventory/sync-master',
              icon: 'icon-puzzle'
            },
            {
              // role: 'sync_master_detail.list',
              name: 'sync_master_detail',
              url: '/inventory/sync-master-detail',
              icon: 'fa fa-tag'
            }
          ]
        }
      ]
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  },
  created: function () {
    let main_page = 'master_material'
    if (this.$route.name == 'home') {
      if (this.$auth.user().group) {
        this.$auth.user().group.forEach(function (item) {
          if (item == process.env.REDIRECT_ROLE_PHD) {
            main_page = 'master_group'
          }
        })
      } else {
        main_page = 'login'
      }
      this.$router.push({name: main_page});
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/containers/Main.vue